module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-bingdao.4dc17080.jpg";